
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"53","height":"53","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Page-1","stroke":"none","stroke-width":"1","fill":"none","fill-rule":"evenodd"}},[_c('g',{attrs:{"id":"Artboard","transform":"translate(-693 -721)","fill":"var(--brand-primary)"}},[_c('g',{attrs:{"id":"Group-2","transform":"translate(693 721)"}},[_c('g',{attrs:{"id":"Group"}},[_c('g',{attrs:{"id":"Logo"}},[_c('path',{attrs:{"d":"M26.711 27.013H53C51.873 39.164 46.278 47.18 36.215 51.06 26.15 54.94 16.645 53 7.694 45.24l9.394-8.971c3.415 2.492 6.623 3.737 9.623 3.737 3 0 5.805-1.143 8.414-3.429l-8.414-9.564z","id":"Bottom"}}),_c('path',{attrs:{"d":"M0 26.329h13.448c.53-6.601 3.667-10.743 9.409-12.425 5.741-1.682 10.582.05 14.523 5.197l10.491-8.58C39.036.62 28.825-2.293 17.237 1.784 6.533 5.55.787 13.732 0 26.329z","id":"Top"}})])])])])])])
          )
        }
      }
    